import React, { useEffect, useState } from 'react';

export const Relogio = () => {
  const [relogio, setRelogio] = useState('');
  const [data, setData] = useState();

  const getHours = () => {
    const dateTZ = new Date().toLocaleString('pt-BR', {
      timeZone: 'America/Sao_Paulo',
    });
    const dataHora = dateTZ.split(' ');
    setRelogio(dataHora[1]);
  };

  const getDate = () => {
    const dateTZ = new Date().toLocaleString('pt-BR', {
      timeZone: 'America/Sao_Paulo',
    });
    const dataHora = dateTZ.split(' ');
    setData(dataHora[0].replace(',', ''));
  };

  useEffect(() => {
    setInterval(() => {
      getHours();
    }, 1000);

    getDate();
  }, []);

  return (
    <div>
      {data} - {relogio}
    </div>
  );
};
